import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron",
  "use": "chevron-usage",
  "viewBox": "0 0 47 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 47 30\" id=\"chevron\"><path fill-rule=\"evenodd\" d=\"M23.5 12.893L6.53 29.864.164 23.5 17.136 6.53 23.5.164 46.835 23.5l-6.364 6.364L23.5 12.894z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol